import React from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Label } from 'reactstrap';

import { IOrderModel } from 'models/Order';
import { ControlledFileUploadInput } from 'components/form';

interface Props {
  order: IOrderModel;
  control: Control<IOrderModel, any>;
  formIsReadOnly: boolean;
  removeAttachment: (attachment: number) => void;
}

const OrderFileUpload: React.FC<Props> = ({ order, control, formIsReadOnly, removeAttachment }) => {
  const { t } = useTranslation('translation');

  return (
    <Label>
      {t('orders.FIELDLABEL_SELECTED_ATTACHMENTS')}
      {order.attachments && !!order.attachments.length && (
        <ul className="attachments">
          {order.attachments.map((a: File, index: number) => (
            <li key={index}>
              {a.name}{' '}
              <i
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  removeAttachment(index);
                }}
                title={t('orders.TITLE_REMOVE_ATTACHMENT')}
                className="fa fa-minus-circle remove-attachment-btn"
              ></i>
            </li>
          ))}
        </ul>
      )}
      <ControlledFileUploadInput<IOrderModel>
        className="hidden"
        control={control}
        fieldName="attachments"
        readonly={formIsReadOnly}
        placeholder={t('orders.FIELD_PLACEHOLDER_ATTACHMENTS')}
      />
      <div className="btn-primary attachment-btn  mt-2">
        {t('orders.FIELD_PLACEHOLDER_ATTACHMENTS')}
      </div>
    </Label>
  );
};

export default OrderFileUpload;
